export const STANDARD_BUSINESS_HOURS = [
  {
    label: 'Standard 24/7',
    value: 'Standard24/7',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const DAYS = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' },
];

export const WORKING_FIELD_NAMES = [
  'mondayWorkingHours.working',
  'tuesdayWorkingHours.working',
  'wednesdayWorkingHours.working',
  'thursdayWorkingHours.working',
  'fridayWorkingHours.working',
  'saturdayWorkingHours.working',
  'sundayWorkingHours.working',
  'mondayLoadingHours.operating',
  'tuesdayLoadingHours.operating',
  'wednesdayLoadingHours.operating',
  'thursdayLoadingHours.operating',
  'fridayLoadingHours.operating',
  'saturdayLoadingHours.operating',
  'sundayLoadingHours.operating',
] as const;

export const OPENING_TIME_FIELD_NAMES = [
  'mondayWorkingHours.openingTime',
  'tuesdayWorkingHours.openingTime',
  'wednesdayWorkingHours.openingTime',
  'thursdayWorkingHours.openingTime',
  'fridayWorkingHours.openingTime',
  'saturdayWorkingHours.openingTime',
  'sundayWorkingHours.openingTime',
  'mondayLoadingHours.openingTime',
  'tuesdayLoadingHours.openingTime',
  'wednesdayLoadingHours.openingTime',
  'thursdayLoadingHours.openingTime',
  'fridayLoadingHours.openingTime',
  'saturdayLoadingHours.openingTime',
  'sundayLoadingHours.openingTime',
] as const;

export const CLOSING_TIME_FIELD_NAMES = [
  'mondayWorkingHours.closingTime',
  'tuesdayWorkingHours.closingTime',
  'wednesdayWorkingHours.closingTime',
  'thursdayWorkingHours.closingTime',
  'fridayWorkingHours.closingTime',
  'saturdayWorkingHours.closingTime',
  'sundayWorkingHours.closingTime',
  'mondayLoadingHours.closingTime',
  'tuesdayLoadingHours.closingTime',
  'wednesdayLoadingHours.closingTime',
  'thursdayLoadingHours.closingTime',
  'fridayLoadingHours.closingTime',
  'saturdayLoadingHours.closingTime',
  'sundayLoadingHours.closingTime',
] as const;
